import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexScrollable',
  setup(__props) {

const CustomScrollbar = defineAsyncComponent(() => import("@/components/theme/advance/scrollable/CustomScrollbar.vue"))
const SmallScroll = defineAsyncComponent(() => import("@/components/theme/advance/scrollable/SmallScroll.vue"))
const BadgesScrollbar = defineAsyncComponent(() => import("@/components/theme/advance/scrollable/BadgesScrollbar.vue"))
const ProfileScrollable = defineAsyncComponent(() => import("@/components/theme/advance/scrollable/ProfileScrollable.vue"))
const ScrollableContent = defineAsyncComponent(() => import("@/components/theme/advance/scrollable/ScrollableContent.vue"))
const HorizontalScrollbar = defineAsyncComponent(() => import("@/components/theme/advance/scrollable/HorizontalScrollbar.vue"))
const BothSide = defineAsyncComponent(() => import("@/components/theme/advance/scrollable/BothSide.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(CustomScrollbar)),
      _createVNode(_unref(SmallScroll)),
      _createVNode(_unref(BadgesScrollbar)),
      _createVNode(_unref(ProfileScrollable)),
      _createVNode(_unref(ScrollableContent)),
      _createVNode(_unref(HorizontalScrollbar)),
      _createVNode(_unref(BothSide))
    ])
  ]))
}
}

})